import { NgModule } from '@angular/core';
import { CitizenExternComponent } from './citizen-extern.component';
import { CitizenExternRoutingModule } from './citizen-extern-routing.module';
import { InjectorModule } from 'src/app/share/injection/injector.module';
import { LoginComponent } from './login/login.component';
import { SearchModule } from '../share/components/search/search.module';
import { StartExternComponent } from './start/start.component';
import { CitizenHeaderExternComponent } from './citizen-header-extern/citizen-header-extern.component';
import { CitizenFooterExternComponent } from './citizen-footer-extern/citizen-footer-extern.component';
import { RegisterComponent } from './register/register.component';
import { ForgetComponent } from './forget/forget.component';
import { EmailVerifyComponent } from './register/email-verify/email-verify.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

@NgModule({
  imports: [
    InjectorModule,
    CitizenExternRoutingModule,
    SearchModule
  ],
  declarations: [
    CitizenExternComponent,
    CitizenHeaderExternComponent,
    CitizenFooterExternComponent,
    StartExternComponent,
    LoginComponent,
    RegisterComponent,
    ForgetComponent,
    EmailVerifyComponent,
    ResetPasswordComponent
  ]
})
export class CitizenExternModule { }
